import AuctionRecordDetails from "./AuctionRecordDetails";
export default AuctionRecordDetails;
